import { getAssetsForContainer } from '../services/asset';

export const LOADING_ASSET = 'LOADING_ASSET';
export const LOAD_ASSETS_FOR_CONTAINER = 'LOAD_ASSETS_FOR_CONTAINER';
export const SET_SELECTED_ASSET_ID = 'SET_SELECTED_ASSET_ID';
export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING';

export const loadingAsset = loading => ({
  type: LOADING_ASSET,
  loading
});

export const loadAssetsForContainer = (container, searchString) => dispatch => {
  dispatch(loadingAsset(true));
  getAssetsForContainer(container, searchString).then(assets =>
    dispatch({
      type: LOAD_ASSETS_FOR_CONTAINER,
      assets
    })
  );
};

export const setSelectedAssetId = asset => ({
  type: SET_SELECTED_ASSET_ID,
  selectedAssetId: asset.id
});

export const updateSearchString = searchString => ({
  type: UPDATE_SEARCH_STRING,
  searchString: searchString
})



// WEBPACK FOOTER //
// ./src/actions/asset.js